import styled from "styled-components";
import { BasicSectionContainer } from "screens/style";
import { colors } from "constants/colors";
import getHelp from "assets/images/getHelp.jpg";
import { styleSizes } from "constants/styleSizes";
export const FooterBox = styled.footer`
  width: 100%;
  height: 100%;
`;

export const FooterContainer = styled.footer`
  width: 100%;
`;

type footerProps = {
  centerWidth: string;
  centerHeight: string;
};

export const FooterBaseContainer = styled(BasicSectionContainer)<footerProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colors.white};

  .footerContentContainer {
    display: flex;
    width: 100%;
    justify-content: center;
  }
`;

export const FooterFormContainer = styled(FooterBaseContainer)`
  align-items: flex-start;
  background-image: none;
  background-color: ${colors.black};

  .footerSubscribeContainer {
    padding: 48px 0;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      padding: 32px 16px 64px 16px;
    }

    .footerSubscribeTitle {
      font-size: 24px;
      font-weight: 300;
      text-align: center;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 24px;
        font-weight: bold;
        line-height: 45px;
      }
    }

    .footerSubscribeDescription {
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: 300;
      margin-top: 32px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 16px;
        line-height: 26px;
      }
    }

    .footerInputContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 48px;
      margin-top: 32px;
      gap: 8px;

      .footerSignUpButton {
        font-size: 16px;
      }

      .footerInput {
        max-width: 343px;
        height: 48px;
        box-sizing: border-box;
        font-size: 15px;
        color: ${colors.secLabel};
      }
    }
  }

  .footerHelpContainer {
    padding: 48px 0;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      padding: 32px 0;
    }

    .footerHelpTitle {
      font-size: 32px;
      font-weight: bold;
      margin-top: 16px;

      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 24px;
      }
    }

    .footerHelpDescription {
      font-size: 19px;
      margin-top: 24px;
      line-height: 29px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 16px;
        line-height: 26px;
      }
    }
  }

  .footerHelpImage {
    width: 50%;
    background-image: url(${getHelp});
    min-width: 627px;
    min-height: 292px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    pointer-events: none;
  }

  /* @media only screen and (max-width: 767px) {

    .footerContentContainer {
      width: 90%;
    }

    .footerInputContainer {
      .footerSignUpButton {
        font-size: 12px;
        margin-left: 10px;
      }
      .footerInput {
        max-width: 90%;
      }
    }
  } */

  /* @media only screen and (max-width: 1200px) {
    .footerContentContainer {
      flex-direction: column;

      .footerHelpContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 0;
        margin-bottom: 16px;

        .footerHelpTitle {
          width: 100%;
          text-align: center;
        }
      }

      .footerHelpImage {
        width: 100%;
        background-size: cover;
        background-position: center;
        margin-bottom: 16px;
      }
    }
  } */
`;

export const FooterDetailsContainer = styled(BasicSectionContainer)`
  color: ${colors.white};
  display: flex;
  justify-content: center;
  background-image: none;
  background-color: ${colors.almostBlack};

  .innerContainer {
    height: 100%;
    .footerDetails {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 329px;
      padding: 67px 0 78px 0;

      @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
        height: auto;
        flex-direction: column;
        align-items: center;
        padding: 40px 0;
        height: auto;
        gap: 32px;
        align-self: center;
      }

      .footerDetail {
        a {
          color: ${colors.white};
          text-decoration: none;
        }
        .siteLink {
          text-decoration: underline;
        }
        .footerDetailsTitle {
          font-size: 18px;
          font-weight: bold;
        }

        .address {
          text-decoration: underline;
          cursor: pointer;
          color: ${colors.white};
          text-decoration: none;
        }

        .footerDetailsContent {
          margin-top: 16px;
          white-space: nowrap;
          div {
            font-size: 16px;
            margin-top: 10px;

            .highLight {
              font-weight: 600;
            }
          }
        }
        @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
          order: 2;
          max-width: 100%;
          width: 100%;
        }
      }

      .logoContainer {
        width: 153px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .bigLogo {
          margin-bottom: 32px;
        }
        @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
          order: 1;
        }
      }
    }
  }
`;

export const FooterBottomContainer = styled(BasicSectionContainer)`
  width: 100%;
  color: ${colors.white};
  display: flex;
  background-color: ${colors.almostBlack};
  border-top: 1px solid ${colors.borderGrey2};
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 16px 24px;
  .footerBottomContent {
    flex: 1;
    color: ${colors.white};
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    max-width: 1229px;
    padding: 0 16px;
    .copy {
      text-align: center;
      white-space: nowrap;
      @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
          width: 100%;
          margin-top: 16px;
          margin-bottom: 16px;
        }
    }


      .policy {
        width: 110px;
        min-width: 110px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 50px;
        @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
          margin-right: 0;
          
        }

        a {
          color: ${colors.white};
          text-decoration: none;
        }
        .terms {
          width: 50%;
          cursor: pointer;
          padding-right: 10px;
          border-right: 1px solid ${colors.borderGrey2};
        }

        .privacy {
          width: 50%;
          margin-left: 10px;
          cursor: pointer;
        }
      }


    .footerBottomIcons {
      width: 120px;
      display: flex;
      font-size: 16px;
      flex: 1;

      .socialMedia {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 16px;
      }
    }
  }
`;
